import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf899274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card min-h-700px" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = {
  class: "card-label fw-bolder fs-3 mb-1",
  style: {"text-transform":"capitalize"}
}
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "justify-content-end position-relative my-1 me-20" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-6 mt-3" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "card-body py-3" }
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-content-center mt-15 mb-15"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border spinner-lg",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table align-middle gs-0 gy-3" }
const _hoisted_17 = { class: "fw-bolder text-muted bg-light mb-5" }
const _hoisted_18 = { class: "ps-4 w-50px rounded-start" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, null, -1))
const _hoisted_20 = { class: "min-w-100px" }
const _hoisted_21 = { class: "min-w-100px" }
const _hoisted_22 = { class: "min-w-140px" }
const _hoisted_23 = { class: "min-w-140px" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-50px rounded-end" }, null, -1))
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "symbol symbol-50px me-2" }
const _hoisted_27 = { class: "text-dark fw-bolder text-hover-primary mb-1 fs-6" }
const _hoisted_28 = {
  key: 0,
  class: "symbol-label svg-icon svg-icon-1 svg-icon-warning ms-1"
}
const _hoisted_29 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_30 = { class: "badge-light-primary badge fs-7 fw-bolder" }
const _hoisted_31 = { class: "badge badge-white fs-8" }
const _hoisted_32 = {
  class: /*#__PURE__*/_normalizeClass(`badge-light-warning badge fs-7 fw-bolder`)
}
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary" }
const _hoisted_35 = { class: "svg-icon svg-icon-2" }
const _hoisted_36 = {
  key: 0,
  class: "d-flex flex-stack flex-wrap pt-10 m-2"
}
const _hoisted_37 = { class: "fs-6 fw-bold text-gray-700" }
const _hoisted_38 = { class: "pagination" }
const _hoisted_39 = { class: "page-item previous" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "previous" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "page-item next" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "next" }, null, -1))
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t("course.researches")), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t("course.nbrResearches", { nb: _ctx.researches.length })), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-solid w-200px ps-14",
            placeholder: _ctx.t('course.search'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterResearches && _ctx.filterResearches(...args)))
          }, null, 40, _hoisted_9), [
            [_vModelText, _ctx.search]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_17, [
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.t("course.title")), 1),
                    _hoisted_19,
                    _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.t("course.subject")), 1),
                    _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.t("course.levels")), 1),
                    _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.t("course.publicationDate")), 1),
                    _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.t("course.deadline")), 1),
                    _hoisted_24
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageRecords, (research, index) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: index,
                      to: `/teacher/research/${research._id}`,
                      custom: ""
                    }, {
                      default: _withCtx(({ navigate }) => [
                        _createElementVNode("tr", {
                          onClick: navigate,
                          class: "hover-tr"
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", {
                                class: _normalizeClass([`bg-light-primary`, "symbol-label"])
                              }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([`svg-icon-primary`, "svg-icon svg-icon-2x"])
                                }, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen005.svg" })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", _hoisted_27, _toDisplayString(research.title), 1),
                            (research.spec)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen003.svg" })
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_29, _toDisplayString(research.module), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_30, _toDisplayString(research.subject.name), 1)
                          ]),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(research.levels, (level) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "fs-8 badge badge-white d-block w-100px",
                                key: level
                              }, _toDisplayString(_ctx.t("dashboard.year" + level)), 1))
                            }), 128))
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.moment(research.date).format("DD/MM/YYYY, H:mm")), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(research.deadline
                            ? _ctx.moment(research.deadline).format(
                                "DD/MM/YYYY, H:mm"
                              )
                            : "-"), 1)
                          ]),
                          _createElementVNode("td", _hoisted_33, [
                            _createElementVNode("a", _hoisted_34, [
                              _createElementVNode("span", _hoisted_35, [
                                _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                              ])
                            ])
                          ])
                        ], 8, _hoisted_25)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.pageRecords.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, " Showing " + _toDisplayString(_ctx.perPage * (_ctx.currentPage - 1) + 1) + " to " + _toDisplayString(_ctx.currentPage == _ctx.totalPages
            ? _ctx.filteredResearches.length
            : _ctx.perPage * _ctx.currentPage) + " of " + _toDisplayString(_ctx.filteredResearches.length) + " entries ", 1),
          _createElementVNode("ul", _hoisted_38, [
            _createElementVNode("li", _hoisted_39, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentPage = 1)),
                class: "page-link"
              }, _hoisted_41)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                class: _normalizeClass(["page-item", i == _ctx.currentPage ? 'active' : ''])
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.currentPage = i),
                  class: "page-link"
                }, _toDisplayString(i), 9, _hoisted_42)
              ], 2))
            }), 128)),
            _createElementVNode("li", _hoisted_43, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
                class: "page-link"
              }, _hoisted_45)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}